import { apiService } from '@/services/APIService';

import { rHandler } from '@/plugins/RHandler';

import { DEFAULT_PARAMS, objectsRHandler } from '@/utils/objectsRHandler';

import { USER_DUPLICATE_SOURCE_MAP } from '@/modules/UserDuplicatesMerges/components/constants';

import User from '../list/user';
import UserRating from '../list/user-rating';
import UserResult from '../list/user-result';
import UserDuplicate from '../list/user-duplicate';

const API_PATH = 'user';

export const UsersManager = {
  objects: {}, // Сюда можно будет привязать какие-нибудь запросы /user/profile
  get public() {
    const apiPath = `public/${API_PATH}s`;
    const { index, show } = objectsRHandler(apiPath, User);
    return {
      index,
      show,
    };
  },
  get ratings() {
    const apiPath = 'ratings';
    const { index, show } = objectsRHandler(apiPath, UserRating);
    return {
      index,
      show,
    };
  },
  get results() {
    const apiPath = 'results/users';
    const { index } = objectsRHandler(apiPath, UserResult);
    return {
      index,
      show({ args = [], params } = DEFAULT_PARAMS) {
        const [id] = args;
        return rHandler(
          apiService.get(`${apiPath}/${id}`, params),
          (response) => ({
            response,
            items: response.data.data.map((i) => new UserResult(i, apiPath)),
          }),
          (error) => ({ error }),
        );
      },
    };
  },
  get duplicates() {
    const apiPath = 'user-duplicates';
    const { index, show } = objectsRHandler(apiPath, UserDuplicate);

    const checkFields = Object.values(USER_DUPLICATE_SOURCE_MAP).map(({ backendField }) => backendField);

    return {
      index,
      show,
      indexWithMerges: (params) => index(params).then(({ items, response, error }) => ({
        response,
        error,
        items: items.filter((item) => checkFields.map((field) => item[field]).some(Boolean)),
      })),
    };
  },
};
